import axios from "axios";

const API = process.env.REACT_APP_API_GO;

export const getUserScreenPreferences = async (screenKey) => {
	const { data } = await axios.get(`${API}/app/user-preferences/${screenKey}`);
	return data;
};

export const saveUserScreenPreferences = async ({ screenKey, viewMode, visibleColumns }) => {
	const { data } = await axios.put(`${API}/app/user-preferences/${screenKey}`, {
		view_mode: viewMode,
		visible_columns: visibleColumns ?? null,
	});
	return data;
};
